import { types, applySnapshot } from "mobx-state-tree";
import { Framework } from "@flint/framework";

const EPubSyncModel = types
  .model("EPubSyncModel", {
    res: types.string,
  })
  .actions((self) => ({
    fetch(ePubISBN) {
      Framework.sendEvent("SYNC_EPUB_DATA", ePubISBN);
    },
    set(response) {
      let rest = `Cloud Sync for book with ISBN ${
        Object.keys(response.data.response)[0]
      } is ${response.data.response[Object.keys(response.data.response)[0]]}`;
      applySnapshot(self, {
        res: rest,
      });
    },
    reset() {
      applySnapshot(self, {
        res: "Oops...Something went wrong. Please try again.",
      });
    },
  }));

export default EPubSyncModel;